import * as React from 'react';
import styled from '@emotion/styled';
import { Flex, themeGet } from '@lightspeed/flame/Core';
import { Button } from '@lightspeed/flame/Button';
import { Text } from '@lightspeed/flame/Text';
import { InputGroup } from '@lightspeed/flame/InputGroup';

import Localize from 'app/src/localize/Localize';
import { usePaymentContext } from '../Store/PaymentState';
import { Theme } from '../PaymentsPanelComponent';
import { PaymentInputField } from './PaymentInputField';

const UserDefinedPaymentTypeWrapper = styled(Flex)<Theme>`
  flex-wrap: wrap;
  padding: ${themeGet('space.1')} ${themeGet('space.0')};
  text-align: end;
`;

export const UserDefinedPaymentTypeForm = ({ name, paymentTypeID }: TSFixMe) => {
  const { paymentMethod, onPaymentChanged, saleManager } = usePaymentContext();
  const { sale = {} } = saleManager.toJSON();
  const isCustomerRequiredForPayment = paymentMethod[paymentTypeID]?.requireCustomer;
  const isCustomerAttachedToSale = sale?.customerID === 0;
  const isPaymentInputDisabled = isCustomerRequiredForPayment && isCustomerAttachedToSale;

  const paymentInputRef = React.useRef(null);

  /**
   * From onMaxButtonClicked from Payment Default View Controller
   * Event handler for when cash 'Max' button is clicked
   */
  const onMaxButtonClicked = () => {
    const totalOfCurrentPayments = saleManager.getTotalPaymentsOfType(paymentTypeID);
    let balance = saleManager.pendingBalance;

    if (!totalOfCurrentPayments.isZero()) {
      balance = balance.plus(totalOfCurrentPayments);
    }
    if (!balance.isZero() && !balance.isNaN()) {
      onPaymentChanged(paymentTypeID, balance);
    }
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    paymentInputRef.current.focus();
  };

  return (
    <>
      <Text
        size="small"
        textTransform="capitalize"
        aria-label={`${name} payment`}
        id={`${name} payment`}
        data-automation={`${name}InputField`}
        role="listitem"
        style={{ wordBreak: 'break-word', wordWrap: 'break-word' }}
        fontWeight="bold"
      >
        {Localize.translate(name)}
      </Text>
      <UserDefinedPaymentTypeWrapper>
        <InputGroup>
          <PaymentInputField
            data-automation={`${name}InputField`}
            name={`${name}_payment`}
            id={`${name}_payment`}
            forwardedRef={paymentInputRef}
            prefix={Localize.getCurrencySymbol()}
            isPaymentInputDisabled={!!isPaymentInputDisabled}
            aria-label={`${name}_payment`}
            onBlur={(value: TSFixMe) => onPaymentChanged(paymentTypeID, value)}
            autoComplete="off"
            value={paymentMethod[paymentTypeID]?.amount}
          />
          {!isPaymentInputDisabled && (
            <Button
              data-automation={`${name}MaxButton`}
              id={`${name}MaxButton`}
              aria-label={`${name}MaxButton`}
              onClick={() => onMaxButtonClicked()}
            >
              <>{Localize.translate('Max')}</>
            </Button>
          )}
        </InputGroup>
      </UserDefinedPaymentTypeWrapper>
    </>
  );
};
